import { useUpdateAtom } from "jotai/utils";
import { Button, ButtonProps } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { openAtom } from "@atoms/wallet";

interface Props extends ButtonProps {
  rounded?: boolean;
}

const StyledButton = withStyles(({ palette }) => ({
  root: {
    fontWeight: 700,
    borderRadius: 16,
    color: "#fff"
  },
}))(Button);

const useStyles = makeStyles({
  rounded: {
    borderRadius: "6px",
    background: '#fb118e',


    "&:hover": {
      background: '#fb118eca',

    },
  },
});

const isAvailable = true;

export default function ConnectButton({ rounded, ...props }: Props) {
  const classes = useStyles();

  const setOpen = useUpdateAtom(openAtom);

  return (
    <StyledButton
      variant='contained'
      color='primary'
      size='small'
      onClick={() => setOpen(true)}
      disabled={!isAvailable}
      {...props}
      className={rounded ? classes.rounded : ""}
    >
      {isAvailable ? "Connect Wallet" : "Available Soon"}
    </StyledButton>
  );
}
